// export const DateFormatForDatePicker = 'MM/dd/yyyy';
// export const DateFormat = 'MM/dd/yyyy';
// export const DateFormat1 = 'dd/MM/yyyy';
// export const DateFormatForBackend = 'MM-DD-yyyy';
export const DateFormatForDatePickerJP = 'yyyy-MM-dd';
export const DateFormatNew = 'yyyy/MM/dd';